// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nDz3","footer":"styles_footer__3EfVF","passCodeTooltip":"styles_passCodeTooltip__37yNq"};